import { createSlice } from '@reduxjs/toolkit'
import { StateUserSlice } from 'types'

interface State {
  idToken?: string
  testVar?: string
  header11: { open: boolean; view: number }
}

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    idToken: 'testToken123',
    testVar: '1',
    header11: { open: false, view: 0 },
  } as StateUserSlice,
  reducers: {
    updateIdToken: {
      reducer(state, action) {
        state.idToken = action.payload
      },
      prepare(idToken) {
        return {
          payload: idToken,
          meta: '',
          error: '',
        }
      },
    },
    updateHeader11: {
      reducer(state, action) {
        state.header11 = action.payload
      },
      prepare(header11) {
        return {
          payload: header11,
          meta: '',
          error: '',
        }
      },
    },
  },
})

export const { updateIdToken, updateHeader11 } = userSlice.actions
